<template>
	<div>
		<h1 class="main-title">Сборы частотности</h1>
		<v-data-table
			:headers="pivotHeaders"
			:items="todayData"
			:loading="loading.savedData"
			hide-default-footer
			dense
		>
		<br/><br/>
		<template v-slot:item.key="{ item }">
			<span>{{findConfigName(item.key)}}</span>
		</template>
		<template v-slot:item.count_main_finish="{ item }">
			<div>
				{{item.count_main_finish}}
				<strong v-if="item.prc_main_finish !== '-'">({{item.prc_main_finish.toLocaleString({maximumFractionDigits: 2})}}%)</strong>
			</div>
		</template>
		<template v-slot:item.count_ch_finish="{ item }">
			<div>
				{{item.count_ch_finish}}
				<strong v-if="item.prc_ch_finish !== '-'">({{item.prc_ch_finish.toLocaleString({maximumFractionDigits: 2})}}%)</strong>
			</div>
		</template>
		</v-data-table>
		<br/>
		<v-divider />
		<br/>
		<br/>
		<h3>Динамика количества запросов для съёма частотности</h3>
		<v-progress-linear
			v-if="loading.savedData"
			indeterminate
			color="blue darken-2"
		/>
		<v-chart
			v-else
			:value="chartOptions"
		/>
		<br/>
		<br/>
		<v-divider />
		<br/>
		<v-tabs v-model="tabId" grow v-if="tabs.length">
			<v-tab v-for="item in tabs" :key="item.id">
				<span>{{item.name}}</span>
				<span v-if="item.name.includes('mobile')">
					<v-icon small
					>
						mdi-cellphone
					</v-icon>
				</span>
			</v-tab>
		</v-tabs>
		<br/>
		<v-data-table
			class="save-table frequency-table"
			:headers="headers"
			:items="tabItems"
			:loading="loading.savedData"
			:items-per-page="-1"
			hide-default-footer
			dense
			@click:row="(item) => handleClick(item)"
		>
			<template v-slot:item.date="{ item }">
				<span>{{item.date ? formatDate(item.date) : '-'}}</span>
			</template>
			<template v-slot:item.prc_main_finish="{ item }">
				<strong v-if="item.prc_main_finish !== undefined && item.prc_main_finish !== '-'">{{item.prc_main_finish.toLocaleString({maximumFractionDigits: 2})}}%</strong>
				<span v-else>-</span>
			</template>
			<template v-slot:item.prc_ch_finish="{ item }">
				<strong v-if="item.prc_ch_finish !== undefined && item.prc_ch_finish !== '-'">{{item.prc_ch_finish.toLocaleString({maximumFractionDigits: 2})}}%</strong>
				<span v-else>-</span>
			</template>
		</v-data-table>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

import chart from '@/components/chart'

export default {
	components: {
		'v-chart': chart
	},

	data () {
		return {
			pivotHeaders: [
				{
					text: ' ',
					value: 'key',
					align: 'start',
					sortable: false
				},
				{
					text: 'MAIN ALL',
					value: 'count_main_all',
					align: 'center',
					sortable: false
				},
				{
					text: 'MAIN Done',
					value: 'count_main_finish',
					align: 'center',
					sortable: false
				},
				{
					text: 'CH ALL',
					value: 'count_ch_all',
					align: 'center',
					sortable: false
				},
				{
					text: 'CH Done',
					value: 'count_ch_finish',
					align: 'center',
					sortable: false
				}
			],
			headers: [
				{
					text: 'Date',
					value: 'date',
					align: 'center',
					sortable: false
				},
				{
					text: 'MAIN ALL',
					value: 'count_main_all',
					align: 'center',
					sortable: false
				},
				{
					text: 'MAIN Done',
					value: 'count_main_finish',
					align: 'center',
					sortable: false
				},
				{
					text: 'MAIN Done %',
					value: 'prc_main_finish',
					align: 'center',
					sortable: false
				},
				{
					text: 'CH ALL',
					value: 'count_ch_all',
					align: 'center',
					sortable: false
				},
				{
					text: 'CH Done',
					value: 'count_ch_finish',
					align: 'center',
					sortable: false
				},
				{
					text: 'CH Done %',
					value: 'prc_ch_finish',
					align: 'center',
					sortable: false
				}
			],
			loading: {
				savedData: true
			},
			tabId: 0
		}
	},

	computed: {
		...mapGetters({
			todayData: 'frequency/todayData',
			tabs: 'frequency/tabs',
			itemsByTab: 'frequency/itemsByTab'
		}),
		...mapState({
			savedData: state => state.frequency.savedData,
			config: state => state.frequency.config
		}),
		currentTab () {
			return this.tabs.length ? this.tabs.find((el) => el.id === this.tabId).name : ''
		},
		tabItems () {
			if (this.currentTab && this.itemsByTab) {
				return this.itemsByTab(this.currentTab)
			}
			return []
		},
		chartOptions () {
			return {
				series: this.prepareChartSeriesData(),
				xAxis: {
					type: 'datetime',
					labels: {
						format: '{value:%d.%m.%Y}'
					}
				},
				yAxis: {
					opposite: false,
					title: { text: null },
					labels: {
						align: 'right',
						style: {
							color: '#bdbdbd',
							fontSize: '12px'
						}
					},
					gridLineDashStyle: 'ShortDash',
					gridLineColor: '#DEDEDE'
				}
			}
		}
	},

	async mounted () {
		try {
			await this.getSavedData()
			await this.getConfig()
		} catch (error) {
			this.$notify({ type: 'error', title: error })
		} finally {
			this.loading.savedData = false
		}
	},

	methods: {
		...mapActions({
			getSavedData: 'frequency/getSavedData',
			getConfig: 'frequency/getConfig'
		}),

		formatDate (date) {
			return date.split('-').reverse().join('.')
		},

		findConfigName (name) {
			if (this.config && this.config.tabs && this.config.tabs.length) {
				const values = Object.values(this.config.tabs)
				return values.find((el) => el.name === name).title
			}
			return name
		},

		handleClick (item) {
			const date = item.date
			this.$router.push(`/frequency/projects?date=${date}`)
		},

		prepareChartSeriesData () {
			if (this.savedData) {
				return Object
					.entries(this.savedData)
					.map(([key, value]) => {
						return {
							name: key,
							data: value
								.map(item => {
									return [this.transformDateToMs(item.date), item.count_ch_all]
								})
								.sort((a, b) => a[0] - b[0])
						}
					})
			}

			return []
		},

		transformDateToMs (date) {
			return new Date(date).getTime()
		}
	}
}
</script>

<style lang="scss">
	.frequency-table > .v-data-table__wrapper > table > tbody > tr:hover {
		cursor: pointer;
	}
</style>
